import e from "../../utilityStyles.module.js";
import { Column as t } from "../Layout/Column.js";
import { useFormField as n } from "./useFormField.js";
import { Row as r } from "../Layout/Row.js";
import { Typography as i } from "../Typography/Typography.js";
import "react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { WarningCircleIcon as s } from "@phosphor-icons/react";
//#region lib/components/FormField/FormField.tsx
function c({ id: c, label: l, helpText: u, errorMessage: d, containerProps: f, children: p }) {
	let { fieldId: m, hasError: h, hasHelpText: g, helpTextId: _, errorMessageId: v } = n({
		id: c,
		helpText: u,
		errorMessage: d
	});
	return /* @__PURE__ */ o(t, {
		spacing: 1,
		...f,
		children: [
			l && /* @__PURE__ */ a(i, {
				variant: "heading-small",
				children: /* @__PURE__ */ a("label", {
					htmlFor: m,
					children: l
				})
			}),
			g && /* @__PURE__ */ a(i, {
				id: _,
				variant: "caption",
				className: e.colorNeutralText,
				children: u
			}),
			p,
			h && /* @__PURE__ */ o(r, {
				spacing: 1,
				className: e.colorErrorText,
				role: "alert",
				children: [/* @__PURE__ */ a(s, {
					size: 12,
					"aria-hidden": !0
				}), /* @__PURE__ */ a(i, {
					id: v,
					variant: "caption",
					children: d
				})]
			})
		]
	});
}
//#endregion
export { c as FormField };
